import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './login/data-access/auth.service';
import {SystemManagementService} from "./admin/data-access/system-management.service";
import resolveConfig from "tailwindcss/resolveConfig";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'PlacementDashboard';
  systemService = inject(SystemManagementService)
  constructor(
    private router: Router,
    public matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private authService: AuthService
  ) {
    // This is registering the custom icons for use throughout the app via <mat-icon>
    this.matIconRegistry.addSvgIcon(
      'dashboard',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/dashboard.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'institution',
       this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/institution.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'calender',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/calender.svg'
      )
    );
  }
  showExitImpersonation = false

  ngOnInit() {
    let reload = localStorage.getItem('primaryColor') == null
    this.systemService.getGlobalBranding().subscribe((response) => {
      if(response.success) {
        localStorage.setItem('primaryColor', response.result.primary_color)
        localStorage.setItem('bannerUrl', response.result.banner_url)
        localStorage.setItem('loginLogoUrl', response.result.login_logo_url)
        localStorage.setItem('loginBackgroundUrl', response.result.login_background_url)
        if(reload)
          location.reload()
      } else {

      }
    })
    if(localStorage.getItem('__OVERRIDE_USER') != null) {
      this.showExitImpersonation = true
    }
  }

  endImpersonation() {
    localStorage.removeItem('__OVERRIDE_USER')
    location.reload()
  }
}
